(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("fascino", [], factory);
	else if(typeof exports === 'object')
		exports["fascino"] = factory();
	else
		root["fascino"] = factory();
})(self, () => {
return 